export default { sha: '15ee0aca14611a6faf0b4ffa01995bb03d2e92ed', buildNumber: 'undefined' }
